import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Calculator } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export const ConfiguratorTeaser = () => {
  const { t, getLocalizedPath } = useLanguage();

  return (
    <section id="configurator" className="pt-8 pb-32 lg:pt-12 lg:pb-40 bg-muted/30">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-card rounded-3xl p-10 md:p-16 border border-border shadow-xl text-center">
            {/* Icon */}
            <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-8">
              <Calculator className="w-10 h-10 text-primary" />
            </div>

            {/* Title */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
              {t.configurator.title} <span className="text-primary">{t.configurator.titleHighlight}</span>
            </h2>

            {/* Subtitle */}
            <p className="text-muted-foreground font-light max-w-xl mx-auto text-lg mb-10">
              {t.configurator.subtitle}
            </p>

            {/* CTA Button */}
            <Link to={getLocalizedPath("/configurator")}>
              <Button
                size="lg"
                className="px-10 py-6 text-lg gap-2 bg-primary hover:bg-primary/90 shadow-glow-blue"
              >
                {t.configurator.goToConfigurator}
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
